{
  "en": {
    "wordClouds": {
      "buttons": {
        "addWord": "Add Word"
      },
      "headers": {
        "options": "Options",
        "wordCloud": "Word Cloud"
      },
      "labels": {
        "show": "Show word cloud",
        "showBeforeSubmit": "Visible before submission",
        "visitorCanWrite": "Visitors may submit words",
        "wordOccurences": "Word Occurences",
        "words": "Words (one per line)"
      },
      "links": {
        "save": "Save as image"
      },
      "placeholders": {
        "addWord": "Add word..."
      }
    }
  }
}
